import { render } from "./DisCiple2.vue?vue&type=template&id=25847b6c&scoped=true&ts=true"
import script from "./DisCiple2.vue?vue&type=script&lang=ts"
export * from "./DisCiple2.vue?vue&type=script&lang=ts"

import "./DisCiple2.vue?vue&type=style&index=0&id=25847b6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25847b6c"]])

export default __exports__